import React, { Component } from 'react';
import { message } from 'antd';
import { StrategyForm } from '../Shared/Form';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class EditView extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        const strategy = await this.props.store.strategyStore.getXStrategy(
            this.props.match.params.id
        );
        this.setState({ strategy });
    }

    handleSubmit(values) {
        this.props.store.strategyStore.updateX(this.props.match.params.id, values).then(() => {
            this.props.history.push('/a/strategies/mako');
            message.success('Strategy updated');
        });
    }
    render() {
        return (
            <div>
                <StrategyForm
                    edit
                    data={this.state.strategy}
                    title="Edit Mako Strategy"
                    onSubmit={this.handleSubmit.bind(this)}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/MakoStrategies/Edit/index.js